import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Utility } from "../../common/utility";
import { BaseUrl } from '../../shared/urls/base.url';
import { AppConstants } from '../../shared/constants/constants'
import { AuthService } from '../../shared/services/auth.service';
import { BaseService } from '../../shared/services/base.service';
import { AuthHelper } from '../../common/auth.helper';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html'
})
export class LandingComponent implements OnInit {
  appConstants = AppConstants;
  navigateUrl: string = '/select-centre';
  href: string;
  footer: string;
  constructor(private router: Router,
    private activeRouter: ActivatedRoute, private authService: AuthService, private baseService: BaseService) { }

  ngOnInit() {
    this.baseService.getBuildVersion().subscribe(response => {
      if (response) {
        this.footer = response['_body'] || null;
      }
    });
  }

  public login() {
    AuthHelper.resetLocalStorage();
    this.authService.login();
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/landing/landing.component.ts